<template>
  <div class="logo">
    <img
      :src="appLogoImage"
      :alt="logoAlt"
      class="logo-img"
    >
  </div>
</template>

<style scoped>
.logo-img {
  max-width: 100%;
  height: auto;
  display: block; /* biar ga ada space bawah */
}
</style>

<script>
import { $themeConfig } from '@themeConfig'

export default {
  name: 'Logo',
  data() {
    return {
      logoAlt: 'Logo',
    }
  },
  computed: {
    appLogoImage() {
      return $themeConfig.app.appLogoImage
    },
  },
}

</script>
